import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Input,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../registration.service';
import { HttpService } from '@core/services/http.service';
import { LocalService } from '@app/@core/services/local.service';
import { forkJoin, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs';
import { query } from '@angular/animations';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';

@Component({
  standalone: false,
  selector: 'app-phone-verification',
  templateUrl: './phone-verification.component.html',
  styleUrls: ['./phone-verification.component.scss']
})
export class PhoneVerificationComponent implements OnInit, OnDestroy {
  @Input() formData: any;
  // Form data
  email: string = '';
  phoneNumber: string = '';
  // OTP functionality
  otpLength: number = 6;
  otpDigits: string[] = [];
  resendTimer: number = 30; // 30 seconds timer for resend
  timeRemaining: number = 30;
  formattedTime: string = '00:30'; private timerInterval: any;
  // OTP validation and attempts
  private readonly correctOtp: string = '628170';
  attempts: number = 0;
  maxAttempts: number = 4; // Max attempts before blocking (5th attempt will block)
  // resendDisabledUntil removed; use timeRemaining for all disables
  resendCount: number = 0;
  maxResendCount: number = 5; // Maximum resend attempts
  otpLockoutDuration: number = 3; // Default 3 minutes - will be updated from API
  otpResendLockoutDuration: number = 15; // Default 15 minutes - will be updated from API
  isBlocked: boolean = false;

  // Toast message state
  showToast: boolean = false;
  toastMessage: string = '';
  toastTitle: string = '';
  toastType: 'success' | 'error' = 'success';
  private toastTimer: any;

  // Phone verification state
  otpSent: boolean = false;
  isPhoneVerified: boolean = false;
  // Link expiration
  date: number = 0;
  // Error handling
  showErrorMessage: boolean = false;
  errorMessage: string = '';
  genericMessages: any[] = [];
  genericMessage: any = {};
  errorMessages: any[] = [];
  validationerrorMessage: any = {};
  toastMessages: any[] = [];
  toastDbMessage: any = {};
  registeredData: any = '';
  // OTP input focus tracking
  inputFocused: boolean[] = [];
  inputBlurred: boolean[] = [];
  showOtpEmptyError: boolean = false;
  showContent: boolean = false;
  private destroy$ = new Subject<void>();
  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly RegistrationService: RegistrationService,
    private readonly httpService: HttpService,
    private readonly sessionStorage: LocalService
  ) {
    this.updateFormattedTime();
  }
  getRegistrationDetails() {
        this.httpService.get(`${API_ENDPOINTS.GET_DETAILS}${this.email}`)
          .pipe(take(1),takeUntil(this.destroy$))
          .subscribe({
          next: (response: any) => {
            this.registeredData = response.data.data;
            if(this.registeredData.cd_registration_status && this.registeredData.cd_registration_status === '4'){
              this.router.navigate(['/reg-form/reg-expired'], { queryParams: { email: this.email,cd_status:'completed' } });
            }else {
          this.showContent = true; // Show content if not expired
        }
          }
        });
    }

  ngOnInit() {
    this.loadOtpValidationRules();
    this.route.queryParams.subscribe(params => {
      if (params['email']) {
        this.email = decodeURIComponent(params['email']);
        this.getRegistrationDetails();
      } else {
        this.email = '';
        this.showContent = false;
      }
      if (params['date']) {
        const dateParam = decodeURIComponent(params['date']);
        // Parse the date parameter and convert to milliseconds
        const urlDate = new Date(dateParam).getTime();
        const urlTimeZone = new Date(dateParam).getTimezoneOffset();
        console.log('URL Date:', urlDate);
        const currentDate = new Date().getTime();
        const currentTimeZone = new Date().getTimezoneOffset();
        console.log('Current Date:', currentDate);
        if (urlTimeZone !== currentTimeZone) {
          this.showContent = false;
          console.log('Link expired - timezone mismatch');
          this.router.navigate(['/reg-form/reg-expired'], { queryParams: { email: this.email } });
          return;
        }

        // Calculate difference in milliseconds
        const timeDifference = currentDate - urlDate;
        if (timeDifference > 86400000) { // 24 hours = 24*60*60*1000 = 86400000 milliseconds 86400000
          console.log('Link expired - more than 24 hours old');
          this.showContent = false;
          this.router.navigate(['/reg-form/reg-expired'], { queryParams: { email: this.email } });
          return;
        } else {
          console.log('Link is valid - within 24 hours');
        }
      }
      console.log('page loading');

      if (params['phone']) {
        this.phoneNumber = decodeURIComponent(params['phone']);
        // Remove any non-digit characters to get clean phone number
        const cleanedPhone = this.phoneNumber.replace(/\D/g, '');
        
        // Format based on length — always display with +1 prefix
        if (cleanedPhone.length === 10) {
          this.phoneNumber = `+1 (${cleanedPhone.substring(0, 3)}) ${cleanedPhone.substring(3, 6)}-${cleanedPhone.substring(6)}`;
        } else if (cleanedPhone.length === 11 && cleanedPhone.startsWith('1')) {
          this.phoneNumber = `+1 (${cleanedPhone.substring(1, 4)}) ${cleanedPhone.substring(4, 7)}-${cleanedPhone.substring(7)}`;
        } else {
          // Keep original if not 10 or 11 digits
          this.phoneNumber = cleanedPhone;
        }

      } else {
        // Default value if not provided in URL
        this.phoneNumber = '';
      }
    });
  //   this.loadData();
  //   this.initializeOtp();
  //   // Auto-send OTP without showing toast or starting timer
  //   this.otpSent = true;
  //   // Don't start timer on initial load as requested
  //   let input = {
  //     email: this.email,
  //     registrationStatus: 3
  //   }
  //   this.RegistrationService.updateRegistrationStatus(input).subscribe((response) => {

  //     console.log('Registration status updated successfully:', response);
  //   }
  //     , (error) => {
  //       console.error('Error sending registration success email:', error);
  //     }
  //   );
  //      const timerState = sessionStorage.getItem(`phoneResendTimer_${this.email}_${this.phoneNumber}`);
  // if (timerState) {
  //   const state = JSON.parse(timerState);
  //   if (state.timeRemaining > 0) {
  //     this.timeRemaining = state.timeRemaining;
  //     this.isBlocked = state.isBlocked;
  //     this.resendCount = state.resendCount;
  //     this.updateFormattedTime();
  //     this.startTimer();
  //   }
  // }
  this.httpService.get(`${API_ENDPOINTS.GET_DETAILS}${this.email}`)
  .pipe(take(1), takeUntil(this.destroy$))
  .subscribe({
    next: (response: any) => {
      this.registeredData = response.data.data;
      if (this.registeredData.cd_registration_status && this.registeredData.cd_registration_status === '4') {
        this.router.navigate(['/reg-form/reg-expired'], { queryParams: { email: this.email, cd_status: 'completed' } });
        return;
      } else {
        // If not 4, update status and load the page
        let input = {
          email: this.email,
          registrationStatus: 3
        };
        this.RegistrationService.updateRegistrationStatus(input).subscribe();
        this.loadData();
        this.initializeOtp();
        this.otpSent = true;
        const timerState = this.sessionStorage.getItem(`phoneResendTimer_${this.email}_${this.phoneNumber}`);
        if (timerState) {
          const state = JSON.parse(timerState);
          if (state.timeRemaining > 0) {
            this.timeRemaining = state.timeRemaining;
            this.isBlocked = state.isBlocked;
            this.resendCount = state.resendCount;
            this.updateFormattedTime();
            this.startTimer();
          }
        }
      }
    }
  });
     this.updateFormattedTime();
  //     this.startTimer();
  //   }
  // }
  this.httpService.get(`${API_ENDPOINTS.GET_DETAILS}${this.email}`)
  .pipe(take(1), takeUntil(this.destroy$))
  .subscribe({
    next: (response: any) => {
      this.registeredData = response.data.data;
      if (this.registeredData.cd_registration_status && this.registeredData.cd_registration_status === '4') {
        this.router.navigate(['/reg-form/reg-expired'], { queryParams: { email: this.email, cd_status: 'completed' } });
        return;
      } else {
        // If not 4, update status and load the page
        let input = {
          email: this.email,
          registrationStatus: 3
        };
        this.RegistrationService.updateRegistrationStatus(input).subscribe();
        this.loadData();
        this.initializeOtp();
        this.otpSent = true;
        const timerState = sessionStorage.getItem(`phoneResendTimer_${this.email}_${this.phoneNumber}`);
        if (timerState) {
          const state = JSON.parse(timerState);
          if (state.timeRemaining > 0) {
            this.timeRemaining = state.timeRemaining;
            this.isBlocked = state.isBlocked;
            this.resendCount = state.resendCount;
            this.updateFormattedTime();
            this.startTimer();
          }
        }
      }
    }
  });
  }

  private loadOtpValidationRules() {
    // Fetch maximum OTP attempts
    this.RegistrationService.getBusinessRuleByKey('Security', 'otp_verification_attempt_limit')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.maxAttempts = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching maximum OTP attempts rule:', error);
        }
      });

    // Fetch maximum OTP resend count
    this.RegistrationService.getBusinessRuleByKey('Security', 'otp_resend_attempt_limit')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.maxResendCount = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching maximum OTP resend count rule:', error);
        }
      });

    // Fetch OTP lockout duration
    this.RegistrationService.getBusinessRuleByKey('Security', 'verify_button_lock_duration')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.otpLockoutDuration = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching OTP lockout duration rule:', error);
        }
      });

    // Fetch OTP resend short disable duration (for normal resend button disable)
    this.RegistrationService.getBusinessRuleByKey('Security', 'resend_code_short_disable_duration')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.resendTimer = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching OTP resend short disable duration rule:', error);
        }
      });

    // Fetch OTP resend long lockout duration (after max attempts reached)
    this.RegistrationService.getBusinessRuleByKey('Security', 'resend_code_lock_duration')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.otpResendLockoutDuration = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching OTP resend long lockout duration rule:', error);
        }
      });
  }

  loadData(): void {
    const errorMessagesData = localStorage.getItem('errorMessages');
    const genericMessagesData = localStorage.getItem('genericMessages');
    const toastMessagesData = localStorage.getItem('toastMessages');
    if (!errorMessagesData || !genericMessagesData || !toastMessagesData) {
      this.loadDropdownData();
    } else {
      const storedErrorMessages = window.localStorage.getItem('errorMessages');
      this.errorMessages = JSON.parse(storedErrorMessages);

      this.validationerrorMessage = {};
      this.errorMessages.forEach(message => {
        if (message.key && message.value !== undefined) {
          this.validationerrorMessage[message.key] = message.value;
        }
      });
      const storedGenericMessages = window.localStorage.getItem('genericMessages');
      this.genericMessages = JSON.parse(storedGenericMessages);

      this.genericMessage = {};
      this.genericMessages.forEach(message => {
        if (message.key && message.value !== undefined) {
          this.genericMessage[message.key] = message.value;
        }
      });
      const storedToastMessages = window.localStorage.getItem('toastMessages');
      this.toastMessages = JSON.parse(storedToastMessages);

      this.toastDbMessage = {};
      this.toastMessages.forEach(message => {
        if (message.key && message.value !== undefined) {
          this.toastDbMessage[message.key] = message.value;
        }
      });
    }
  }
  private async loadDropdownData() {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES')
    ]).subscribe({
      next: (item: any) => {
        this.errorMessages = item[0].data;
        this.toastMessages = item[1].data;
        this.genericMessages = item[2].data;
        // Process generic messages to make them easily accessible by key
        this.validationerrorMessage = {};
        this.errorMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.validationerrorMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('errorMessages', JSON.stringify(this.errorMessages));
        this.toastDbMessage = {};
        this.toastMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.toastDbMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('toastMessages', JSON.stringify(this.toastMessages));
        console.log(item);
        this.genericMessage = {};
        this.genericMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.genericMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('genericMessages', JSON.stringify(this.genericMessages));
      },
      error: error => {
        console.error('Error loading dropdown data:', error);
      }
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }
  initializeOtp() {
    this.otpDigits = new Array(this.otpLength).fill('');
    this.inputFocused = new Array(this.otpLength).fill(false);
    this.inputBlurred = new Array(this.otpLength).fill(false);
    this.showOtpEmptyError = false;
    // Initialize timeRemaining to 0 so timer doesn't show initially
    this.timeRemaining = 0;
    this.updateFormattedTime();
  }

  onInputChange(event: any, index: number) {
    const value = event.target.value;

    // Only allow single digit numbers
    if (value.length > 1) {
      event.target.value = value.slice(-1);
    }

    if (!/^\d*$/.test(event.target.value)) {
      event.target.value = '';
      return;
    }

    this.otpDigits[index] = event.target.value;

    // Clear error state when a value is entered
    if (event.target.value) {
      this.inputBlurred[index] = false;
      
      // Check if we should still show the error message
      const anyEmptyBlurred = this.inputBlurred.some((blurred, idx) => 
        blurred && this.otpDigits[idx] === '');
      this.showOtpEmptyError = anyEmptyBlurred;
    }

    // Auto-focus next input
    if (event.target.value && index < this.otpLength - 1) {
      const nextInput = event.target.nextElementSibling;
      if (nextInput) {
        nextInput.focus();
      }
    }

    this.checkIfComplete();
  }

  onKeyDown(event: any, index: number) {
    // Handle backspace
    if (event.key === 'Backspace' && !event.target.value && index > 0) {
      const prevInput = event.target.previousElementSibling;
      if (prevInput) {
        prevInput.focus();
        this.otpDigits[index - 1] = '';
        prevInput.value = '';
      }
    }
  }

  onPaste(event: any) {
    event.preventDefault();
    const pastedData = event.clipboardData.getData('text');
    const digits = pastedData
      .replace(/\D/g, '')
      .split('')
      .slice(0, this.otpLength);

    for (let i = 0; i < this.otpLength; i++) {
      this.otpDigits[i] = digits[i] || '';
      const input = document.getElementById(
        `otp-input-${i}`
      ) as HTMLInputElement;
      if (input) {
        input.value = this.otpDigits[i];
      }
    }

    this.checkIfComplete();
  }

  checkIfComplete() {
    const isComplete = this.otpDigits.every((digit) => digit !== '');
    if (isComplete) {
      const otpValue = this.otpDigits.join('');
      console.log('OTP entered:', otpValue);
    }
  }

  validateOtp() {
    const enteredOtp = this.otpDigits.join('');

    if (enteredOtp.length !== this.otpLength) {
      this.showErrorMessage = true;
      this.errorMessage = 'Please enter all 6 digits';
      return;
    }
    if (enteredOtp === this.correctOtp) {
      this.isPhoneVerified = true;
      this.showErrorMessage = false;
      this.showOtpEmptyError = false; // Clear empty OTP error
      this.clearTimer();
      // Navigate to success page
    } else {
      this.attempts++;
      this.showErrorMessage = true;
      this.showOtpEmptyError = false; // Clear empty OTP error

      if (this.attempts >= this.maxAttempts) {
        this.handleTooManyAttempts();
      } else {
        // Show inline error
        this.errorMessage = 'Incorrect OTP. Please try again.';
        this.clearInputs();
        // Always show toast for wrong OTP (1st to 5th attempt)
        this.showOtpErrorToast();
      }
    }
  }

  // Helper method to handle too many attempts
  private handleTooManyAttempts() {
    this.isBlocked = true;
    this.showErrorMessage = true;
    this.errorMessage = 'Too many incorrect attempts.';
    this.clearInputs();
    this.timeRemaining = this.otpLockoutDuration * 60;
    this.updateFormattedTime();
    this.clearTimer();
    this.startTimer();
    // Show blocked toast
    this.toastTitle = '';
    this.toastMessage = `For your security, verification has been temporarily locked due to multiple incorrect code entries. You can try again in ${this.otpLockoutDuration} minutes.`;
    this.toastType = 'error';
    this.showToast = true;
    this.setToastTimer();
  }

  // New toast message methods for each specific case

  //   showOtpErrorToast() {
  //   this.toastTitle = '';
  //   this.toastMessage = this.toastDbMessage['T0005'];
  //   this.toastType = 'error';
  //   this.showToast = true;
  //   this.setToastTimer();
  // }

  showOtpErrorToast() {
    this.toastTitle = '';
    
    const remainingAttempts = this.maxAttempts - this.attempts;
    
    if (this.attempts >= this.maxAttempts) {
      // Lockout message
      this.toastMessage = `For your security, verification has been temporarily locked due to multiple incorrect code entries. You can try again in ${this.otpLockoutDuration} minutes.`;
    } else if (remainingAttempts > 0) {
      this.toastMessage = `The code entered is incorrect. You have ${remainingAttempts} attempt(s) remaining before verification is temporarily locked.`;
    } else {
      this.toastMessage = this.toastDbMessage['T0005'];
    }
    this.toastType = 'error';
    this.showToast = true;
    this.setToastTimer();
  }

  showResendLimitToast() {
    this.toastTitle = 'Resend Limit Reached';
    this.toastMessage = 'You have reached the maximum number of resend attempts. Please try again later.';
    this.toastType = 'error';
    this.showToast = true;
    this.setToastTimer();
  }

  showContactSupportToast() {
    this.toastTitle = 'Your information has been sent to our support team';
    this.toastMessage = `A confirmation email has been sent to ${this.email}`;
    this.toastType = 'success';
    this.showToast = true;
    this.setToastTimer();
  }

  setToastTimer() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }

    this.toastTimer = setTimeout(() => {
      this.showToast = false;
    }, 10000); // 10 seconds display time
  }

  closeToast() {
    this.showToast = false;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }

  startTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

         this.sessionStorage.setItem(
    `phoneResendTimer_${this.email}_${this.phoneNumber}`,
    JSON.stringify({
      timeRemaining: this.timeRemaining,
      isBlocked: this.isBlocked,
      resendCount: this.resendCount
    })
  );
      this.timerInterval = setInterval(() => {
    if (this.timeRemaining > 0) {
      this.timeRemaining--;
      this.updateFormattedTime();
      this.cdr.markForCheck();

      // Update timer state every tick
      this.sessionStorage.setItem(
        `phoneResendTimer_${this.email}_${this.phoneNumber}`,
        JSON.stringify({
          timeRemaining: this.timeRemaining,
          isBlocked: this.isBlocked,
          resendCount: this.resendCount
        })
      );
    } else {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
      if (this.isBlocked) {
        this.isBlocked = false;
        this.resendCount = 0;
      }
    this.sessionStorage.removeItem(`phoneResendTimer_${this.email}_${this.phoneNumber}`);
    }
  }, 1000);
}

  clearTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  updateFormattedTime() {
    const minutes = Math.floor(this.timeRemaining / 60);
    const seconds = this.timeRemaining % 60;
    this.formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }
  onResendCode() {
    // Check if resend is disabled due to timer
    if (this.isBlocked || this.timeRemaining > 0) {
      this.showErrorMessage = true;
      this.errorMessage = 'Resend Code is disabled. Please try again later.';
      return;
    }
    // Max resend count triggers long lockout
    if (this.resendCount === this.maxResendCount) {
      this.isBlocked = true;
      this.timeRemaining = this.otpResendLockoutDuration * 60;
      this.updateFormattedTime();
      this.clearTimer();
      this.startTimer();
      // Do NOT show T0040 toast on 15 min lockout
      return;
    }
    // First 5 clicks: allow resend, show 30s timer
    this.resendCount++;
    this.initializeOtp();
    this.clearInputs();
    this.showErrorMessage = false;
    this.errorMessage = '';
    this.showOtpEmptyError = false;

    this.timeRemaining = this.resendTimer;
    this.updateFormattedTime();
    this.startTimer();
    // Show toast message T0040 on every successful resend (not on lockout)
    const toastText = this.toastDbMessage['T0050'] || 'A new verification code has been sent to your registered phone number.';
    this.toastTitle = '';
    this.toastMessage = toastText;
    this.toastType = 'success';
    this.showToast = true;
    this.setToastTimer();
}

  clearInputs() {
    for (let i = 0; i < this.otpLength; i++) {
      const input = document.getElementById(
        `otp-input-${i}`
      ) as HTMLInputElement;
      if (input) {
        input.value = '';
      }
    }
    this.otpDigits = new Array(this.otpLength).fill('');
    this.inputFocused = new Array(this.otpLength).fill(false);
    this.inputBlurred = new Array(this.otpLength).fill(false);
    this.showOtpEmptyError = false;
  }
  
  // Focus event handler
  onInputFocus(index: number) {
    this.inputFocused[index] = true;
  }
  
  // Blur event handler
  onInputBlur(index: number) {
    this.inputBlurred[index] = true;
    
    // Check if the input is empty after blur and was previously focused
    if (this.inputFocused[index] && this.otpDigits[index] === '') {
      this.showOtpEmptyError = true;
    }
    
    // Update the UI
    this.cdr.markForCheck();
  }

  getInputIds() {
    return Array(this.otpLength)
      .fill(0)
      .map((_, index) => index);
  }

  onVerifyPhoneNumber() {
    if (this.isBlocked || this.timeRemaining > 0) {
      // Do nothing, button is disabled
      return;
    }
    
    // Check for empty inputs and show error
    if (this.otpDigits.some(digit => digit === '')) {
      this.showOtpEmptyError = true;
      return;
    }
    
    // Otherwise validate OTP
    this.validateOtp();
    const cleanedPhoneNumber = this.phoneNumber.replace(/\D/g, '').replace(/^1(\d{10})$/, '$1');
    if (!this.showErrorMessage) {
      let input = {
          otp: this.otpDigits.join(''),
          email: this.email,
          phone: cleanedPhoneNumber,
          is_recovery_email_verified: false
        };
        this.RegistrationService.updatePhone(input).subscribe({
          next: data => {
            if (data.data && data.data.success === true) {
              this.router.navigate(['/reg-form/create-password'], { queryParams: { email: this.email } })
              console.log('Phone number updated successfully:', data);
            } else {
              console.log('Failed to verify phone number:', data);
            }

          },
          error: error => {
            console.error('Error checking person:', error);
          }
        });
      }
    }
  canResend(): boolean {
    return this.otpSent && this.timeRemaining === 0 && this.resendCount < this.maxResendCount;
  }

  navigateToPhoneUpdate(): void {
    const cleanedPhoneNumber = this.phoneNumber.replace(/\D/g, '');
    this.router.navigate(['../phone-update'], {
      relativeTo: this.route,
      queryParams: {
        email: this.email,
        phone: cleanedPhoneNumber,
        source: 'phone-verification'
      }
    });
  }
  isRecoveryOtpDisabled(i: number): boolean {
  return !this.otpSent || this.isPhoneVerified;
}
isResendDisabled(): boolean {
  return this.timeRemaining > 0 || this.isBlocked;
}
}

